import React, { useContext } from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Ionicons } from '@expo/vector-icons';
import TripsListScreen from '../screens/TripsListScreen';
import TripDetailScreen from '../screens/TripDetailScreen';
import AddTripScreen from '../screens/AddTripScreen';
import SettingsScreen from '../screens/SettingsScreen';
import AuthScreen from '../screens/AuthScreen';
import EmailInboxScreen from '../screens/EmailInboxScreen';
import IconTest from '../screens/IconTest';
import TestScreen from '../screens/TestScreen';
import { FirebaseAuthContext } from '../context/FirebaseAuthContext';

export type RootStackParamList = {
  Auth: undefined;
  Main: undefined;
  TripDetail: { tripId: string };
  EmailInbox: undefined;
  IconTest: undefined;
};

export type MainTabParamList = {
  Trips: undefined;
  AddTrip: undefined;
  Inbox: undefined;
  Settings: undefined;
};

const Stack = createNativeStackNavigator<RootStackParamList>();
const Tab = createBottomTabNavigator<MainTabParamList>();

function MainTabs() {
  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        headerShown: false,
        tabBarIcon: ({ focused, color, size }) => {
          let iconName: keyof typeof Ionicons.glyphMap;

          if (route.name === 'Trips') {
            iconName = focused ? 'airplane' : 'airplane-outline';
          } else if (route.name === 'AddTrip') {
            iconName = focused ? 'add-circle' : 'add-circle-outline';
          } else if (route.name === 'Inbox') {
            iconName = focused ? 'mail' : 'mail-outline';
          } else if (route.name === 'Settings') {
            iconName = focused ? 'settings' : 'settings-outline';
          } else {
            iconName = 'help-outline';
          }

          return <Ionicons name={iconName} size={size} color={color} />;
        },
        tabBarActiveTintColor: '#6200ea',
        tabBarInactiveTintColor: 'gray',
        tabBarStyle: {
          position: 'relative',
          height: 60,
        },
      })}
    >
      <Tab.Screen 
        name="Trips" 
        component={TripsListScreen}
        options={{ title: 'My Trips' }}
      />
      <Tab.Screen 
        name="AddTrip" 
        component={AddTripScreen}
        options={{ title: 'Add Trip' }}
      />
      <Tab.Screen 
        name="Inbox" 
        component={EmailInboxScreen}
        options={{ title: 'Email Inbox' }}
      />
      <Tab.Screen 
        name="Settings" 
        component={SettingsScreen}
        options={{ title: 'Settings' }}
      />
    </Tab.Navigator>
  );
}

export default function RootNavigator() {
  const authContext = useContext(FirebaseAuthContext);
  const isAuthenticated = !!authContext?.user;

  return (
    <Stack.Navigator>
      {!isAuthenticated ? (
        <Stack.Screen 
          name="Auth" 
          component={AuthScreen}
          options={{ headerShown: false }}
        />
      ) : (
        <>
          <Stack.Screen 
            name="Main" 
            component={MainTabs}
            options={{ headerShown: false }}
          />
          <Stack.Screen 
            name="TripDetail" 
            component={TripDetailScreen}
            options={{ title: 'Trip Details' }}
          />
          <Stack.Screen 
            name="IconTest" 
            component={IconTest}
            options={{ title: 'Icon Test' }}
          />
        </>
      )}
    </Stack.Navigator>
  );
}